module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-2\" style=\"padding-top: 5px; font-size: 11px;\">Name</div>\r\n    <div class=\"col-md-10\">\r\n       <input type=\"text\" name=\"name\" value=\"")
    ; __append(escapeFn(name))
    ; __append("\" />\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex\">\r\n        <input type=\"checkbox\" name=\"isDefault\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Is default stage</label>\r\n    </div>\r\n    <div class=\"col-md-12 prop-sublabel form-group-flex\">\r\n        <input type=\"checkbox\" name=\"isClosed\" class=\"form-radio-group\">\r\n        <label class=\"form-group-label\">Is closed stage</label>\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n")
  }
  return __output;

}